module.exports = __webpack_public_path__ + "static/media/baekseok.b06baa30.png";